import kebabcase from 'lodash.kebabcase';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import formFieldSelectDropdownArrow from '../../images/svg/form-field-select-dropdown-arrow.svg';
import formFieldValidIcon from '../../images/svg/form-field-valid.svg';

const OptionPropTypes = PropTypes.shape({
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
});

class FormFieldSelectComponent extends Component {
    static propTypes = {
        assignRef: PropTypes.func.isRequired,
        formFieldSelectPlaceholderFallback: PropTypes.string.isRequired,
        isFormSubmitted: PropTypes.bool.isRequired,
        label: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        onChange: PropTypes.func.isRequired,
        options: PropTypes.arrayOf(OptionPropTypes).isRequired,
        placeholder: PropTypes.string,
        submittedFieldValue: OptionPropTypes,
        type: PropTypes.string.isRequired,
    };

    state = {
        isOptionSelected: false,
    };

    selectRef = React.createRef();

    onChange = (event) => {
        const selectedValues = [event.target.options[event.target.selectedIndex]];
        const selectedOptions = Array.from(selectedValues).map(({ label, value }) => ({ label, name: value }));
        this.props.onChange(selectedOptions);
        this.setState({ isOptionSelected: true });
    };

    render() {
        const {
            formFieldSelectPlaceholderFallback,
            isFormSubmitted,
            label,
            name,
            options,
            placeholder,
            submittedFieldValue,
            type,
        } = this.props;
        const selectPlaceholder = placeholder || formFieldSelectPlaceholderFallback;
        const selectAttrs = {
            id: kebabcase(name),
        };
        const isSelected = this.state.isOptionSelected || isFormSubmitted;
        const optionList = [
            <option key={'default'} value={'default'} disabled={true}>
                {selectPlaceholder}
            </option>,
            ...options.map((option) => {
                return (
                    <option className={option.name} key={option.name} value={option.name}>
                        {option.label}
                    </option>
                );
            }),
        ];

        return (
            <div className="form-group">
                <label htmlFor={selectAttrs.id} className="control-label">
                    {label}
                </label>
                <select
                    id={selectAttrs.id}
                    className="form-control"
                    disabled={isSelected}
                    onChange={this.onChange}
                    ref={(reference) => {
                        this.selectRef = reference;
                        this.props.assignRef(this.selectRef);
                    }}
                    required
                    type={type}
                    defaultValue={(submittedFieldValue && submittedFieldValue.name) || 'default'}
                >
                    {optionList}
                </select>
                <img
                    className={[
                        'select-dropdown-icon',
                        'select-dropdown-icon--select',
                        !isSelected ? 'select-dropdown-icon--visible' : '',
                    ].join(' ')}
                    src={formFieldSelectDropdownArrow}
                    alt="dropdown arrow"
                />
                <img
                    className={[
                        'select-dropdown-icon',
                        'select-dropdown-icon--success',
                        isSelected ? 'select-dropdown-icon--visible' : '',
                    ].join(' ')}
                    src={formFieldValidIcon}
                    alt="successful validation"
                />
            </div>
        );
    }
}

export default connect(
    ({
        ui: {
            text: { formFieldSelectPlaceholderFallback },
        },
    }) => ({
        formFieldSelectPlaceholderFallback,
    }),
    undefined,
    undefined,
    { forwardRef: true },
)(FormFieldSelectComponent);
